import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useSelector } from 'react-redux';

// import images
import SplashScreenImageEN from '../../../images/static/splash_screen_en.jpg';
import SplashScreenImageES from '../../../images/static/splash_screen_es.jpg';

const animationVariants = {
  hidden: { y: 0 },
  visible: {
    y: 0,
    transition: { ease: 'easeInOut', duration: 0.75 },
  },
  exit: { y: '100vh', transition: { ease: 'easeInOut', duration: 0.5 } },
};

const imageVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { ease: 'easeInOut', duration: 0.75 },
  },
};

function SplashScreen() {
  const locale = useSelector((state) => state.app.locale);

  const [isVisible, setIsVisible] = useState(true);

  React.useEffect(() => {
    document.body.style.overflow = 'hidden';
    const timer = setTimeout(() => {
      setIsVisible(false);
      document.body.style.overflow = 'auto';
    }, 3000); // Adjust the duration as needed

    return () => clearTimeout(timer);
  }, []);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          style={{
            position: 'fixed',
            backgroundColor: '#8fccf1',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 99999,
            maxWidth: '660px',
          }}
          variants={animationVariants}
          initial="hidden"
          animate="visible"
          exit="exit"
          key={'splash-screen'}
        >
          <motion.img
            src={locale === 'en' ? SplashScreenImageEN : SplashScreenImageES}
            alt="Splash Screen"
            variants={imageVariants}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default SplashScreen;
